<template>
  <div style="width: 100%">
    <v-autocomplete
        v-model="sport"
        :items="searchResults"
        :loading="isLoading"
        hide-no-data
        hide-selected
        item-text="desc"
        item-value="_id"
        :label="$t('sports')"
        :placeholder="$t('startTypingToSearch')"
        @change="setResult()"
        deletable-chips
        chips
        small-chips
        return-object
        :hint="(searchResults.length == 0 && showHint) ? $t('noResults'):''"
    ></v-autocomplete>
  </div>

</template>

<script>
import {mapActions} from 'vuex';

export default {
  name: "SportsAutocomplete",
  props: {
    model: {
      default: () => ''
    },
    index:{
      default: () => -1
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    sport: {},
    searchResults: [],
    isLoading: false,
    search: null,
    showHint: false
  }),
  async created() {

    this.isLoading = true
    var result = await this.getItems()
    if (result.length > 0) {

      result.sort((a, b) => a.name.localeCompare(b.name)).filter

      result.map(x => this.searchResults.push({
        'desc': x.name,
        '_id': x._id
      }))

      if(this.model && this.model != ''){
        var find = _.find(result,{'_id': this.model})
        if(find){
          this.sport = find
        }
      }

    } else {

      this.showHint = true

    }

    this.isLoading = false
  },
  watch: {
  },
  methods:{
    ...mapActions({
      'getItems':'sports/index'
    }),
    setResult() {
      if(this.index >= 0){

        if(this.sport && this.sport._id){
          this.$emit('message',{'sport':this.sport, 'index':this.index})
        }else {
          this.searchResults = []
          this.$emit('message',{'sport':'', 'index':this.index})
        }

      }else {

        if(this.sport && this.sport._id){
          this.$emit('message',this.sport)
        }else {
          this.$emit('message','')
        }

      }


    }
  }

}
</script>

<style scoped>

</style>